import {
  useEffect,
  useRef,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Editor from "@monaco-editor/react";
import MonokaiTheme from "monaco-themes/themes/Monokai Bright.json";
import { useLocation } from "react-router-dom";
import axios from "axios";
import queryString from "query-string";
import "../../assets/css/script-editor.scss";

const RUN_EXAMPLE = "run-example";
const WEBHWP_EXAMPLE = "webhwp-example";

const ScriptEditor = forwardRef((props, ref) => {
  const [ExampleScript, setExampleScript] = useState("");
  const [initScript, setInitScript] = useState("");

  const editorRef = useRef(null);
  const location = useLocation();
  const query = queryString.parse(location.search);

  const HwpCtrl = props.hwpCtrl;
  const pathList = location.pathname.split("/");
  const examplePageType = pathList[pathList.length - 1];

  useImperativeHandle(ref, () => ({
    initEditorBtn,
    executeEditorBtn,
  }));

  //example, init script devcenter에서 받은 후 set
  useEffect(() => {
    let path = query.path
    if (examplePageType === RUN_EXAMPLE) {
      axios
        .get("/api/editor/example", {
          params: {
            path: path + query.main,
          },
        })
        .then((res) => {
          setExampleScript(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
      axios
        .get("/api/editor/init", {
          params: {
            path: path + query.init,
          },
        })
        .then((res) => {
          setInitScript(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [location.pathname]);

  useEffect(() => {
    //hwpCtrl 마운트 완료시 init script 초기 설정
    if (examplePageType === RUN_EXAMPLE && initScript === "") return;
    if (props.hwpCtrlMsg === "ok") new Function("HwpCtrl", initScript)(HwpCtrl);
  }, [props.hwpCtrlMsg, initScript]);

  //초기화 버튼 클릭시
  function initEditorBtn() {
    //기안기 reload
    document.getElementById("Document_HwpCtrl").contentWindow.location.reload();
    editorRef.current.setValue(ExampleScript);
    if (examplePageType === WEBHWP_EXAMPLE) editorRef.current.focus();
  }

  //실행 버튼 글릭시 에디터 내부 코드실행
  function executeEditorBtn() {
    const script = editorRef.current.getValue();
    new Function(["HwpCtrl", "baseurl"], script)(HwpCtrl, query.path);
  }

  function handleEditorDidMount(editor, monaco) {
    editorRef.current = editor;

    //테마설정
    monaco.editor.defineTheme("monokai", MonokaiTheme);
    monaco.editor.setTheme("monokai");

    // '/webhwp-example' 메뉴 > 도구 > 웹한글기안기 로 접속했을 경우 에디터 포커싱
    if (examplePageType === WEBHWP_EXAMPLE) editor.focus();
  }

  return (
    <Box id="script-editor">
      <Box className="editor">
        <Box className="editor-title">
          <Typography className="typo">Script Editor</Typography>
        </Box>
        <Editor
          height="900px"
          width="auto"
          language="javascript"
          defaultValue={ExampleScript}
          onMount={handleEditorDidMount}
          options={{
            fontSize: 16,
            minimap: { enabled: false }, // 에디터 오른편 미니맵 활성화 true/false
            scrollbar: {
              vertical: "auto",
              horizontal: "auto",
            },
            contextmenu: false,
            padding: {
              top: 15,
              bottom: 10,
            },
            quickSuggestions: false, //스니펫 제안 옵션 true/false
            wordWrap: "on", //자동 줄바꿈 옵션 ON/OFF
            lineNumbers: {
              LineNubersType: "off", //에디터 줄번호 ON/OFF
            },
            lineDecorationsWidth: "1px", //줄번호 가로넓이
          }}
        />
      </Box>
    </Box>
  );
});

export default ScriptEditor;
